import React from 'react';
import T, { oneOfType } from 'prop-types';
import cx from 'classnames';
import AppIcon from '../../../../components/AppIcon';

const CompanyMediaObject = ({ name, ticker, icon, className, size = 40, onClick }) => (
  <div className={cx('company-media-object ignore-onclickoutside', className)} onClick={onClick}>
    <div className="company-media-object__icon">
      <AppIcon
        alt={name}
        url={icon}
        withBorder
        size={size}
        defaultBrokenNoStoreIcon="hicon-company-fill"
      />
    </div>
    <div className="company-media-object__body">
      <p className="company-media-object__body-ticker">{ticker}</p>
      <p className="company-media-object__body-name">{name}</p>
    </div>
  </div>
);

CompanyMediaObject.propTypes = {
  name: T.string.isRequired,
  ticker: oneOfType([T.string, T.node]),
  icon: T.string,
  className: T.string,
  size: T.number,
  onClick: T.func,
};

export default CompanyMediaObject;
